package com.mps.asc_app.data.bookings

import kotlinx.serialization.Serializable

@Serializable
data class BookingPlayer(
    val userId: String,
    val displayNameSnapshot: String? = null,
    val privacyConsentAcceptedSnapshot: Boolean? = null,
)
